import "./preloder.css";
// import Loderimg from ".././assets/lodaer.gif";

const Loderimg= "https://res.cloudinary.com/dmnpdzcvd/image/upload/v1744655004/lodaer_d44hkv.gif";

function Preloader() {

  return (
    
    <div className="preloader">
      <div className="loadercontainer">
        <img src={Loderimg} alt="Loderimg" className="loderimg" /> <br />
        <h2 className="load-text">Loading...</h2>
      </div>
    </div>
  );
}
export default Preloader;
